<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('foodcategories') }}</div>
      <div>
        <router-link class="btn-blue" :to="'edit-food-categories/?fc_id='+fc_id">{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="food-categories"
        >{{ $t('foodcategories') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('foodcategory', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{fc_category}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('parent') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{fc_parent_label}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('foodorder') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{fc_order}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('icon') }}</div>
              <img :sr="URL_BASE+fc_icon_url" />
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                v-if="fc_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('active') }}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">{{ $t('inactive') }}</div>
            </div>
          </div>

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ created_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{updated_at | dateparse}}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import { BASEURL } from "@/config/index.js";

export default {
  components: { Multiselect },
  data() {
    return {
      fc_category: "",
      fc_parent_id: 0,
      fc_parent_label: "",
      fc_order: "",
      fc_is_active: true,
      fc_icon_url: "",
      is_parent: false,
      fc_id: "",
      created_at: "",
      created_by: "",
      updated_by: "",
      updated_at: "",
      URL_BASE: BASEURL
    };
  },
  beforeMount() {
    this.fc_id = this.$route.query.fc_id;
  },
  mounted() {
    this.getVendorsList();
  },
  methods: {
    getVendorsList: function() {
      let payload = {
        tableName: "ms_food_categories"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records;
            this.ms_food_categories.map(x => {
              if (this.fc_id == x.fc_id) {
                this.fc_category = x.fc_category;
                this.fc_parent_id = x.fc_parent_id;
                this.fc_order = x.fc_order;
                this.fc_is_active = x.fc_is_active;
                this.created_at = x.created_at;
                this.updated_at = x.updated_at;
                this.fc_icon_url = x.fc_icon_url;
                this.getViewUsersDetails(x.created_by, "created_by");
                this.getViewUsersDetails(x.updated_by, "updated_by");
              }
              this.ms_food_categories.map(y => {
                if (this.fc_parent_id > 0 && this.fc_parent_id == y.fc_id) {
                  this.is_parent = true;
                  this.fc_parent_label = y.fc_category;
                }
              });
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    }
  }
};
</script>

 


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/viewFoodCategories.vue